import {
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ArrayInput,
  SimpleFormIterator,
  AutocompleteInput,
  ImageInput,
  ImageField,
  LongTextInput,
  FileField,
  FileInput
} from "react-admin";
import { month, year } from "../../constant/Date";
import React from "react";
import { typeMessage } from "../../constant/TypeMessage";
import { required } from "../../services/validate";
import { SUPERADMIN } from "../../constant/TypeRole";

class MessageForm extends React.Component {
  state = {
    project: null,
    send_to: null,
    type: null
  };
  render() {
    const redirect = (basePath, id, data) => `/message`;
    const { send_to, type, project } = this.state;
    const props = this.props;

    const role = localStorage.getItem("role");
    const myProject = JSON.parse(localStorage.getItem("project"));
    const filter = role ? (role === SUPERADMIN ? {} : { _id: myProject }) : {};

    // const d = new Date();
    // const thisMonth = parseInt(d.getMonth());
    // const thisYear = parseInt(d.getFullYear());
    return (
      <SimpleForm {...props} redirect={redirect}>
        <ReferenceInput
          validate={[required()]}
          disabled={project ? true : false}
          onChange={(event, key, payload) => this.setState({ project: key })}
          source="project"
          reference="project"
          filter={filter}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
        {project && (
          <CustomSelectInput
            validate={[required()]}
            source="type"
            choices={typeMessage.filter(f => f.id !== 2 && f.id !== 6)}
            onChangeCustomHandler={key => {
              this.setState({ type: key });
            }}
          />
        )}
        {type === 1 && (
          <CustomSelectInput
            validate={[required()]}
            source="send_to"
            choices={[
              { id: "*", name: "ALL" },
              { id: "condo", name: "Condo" },
              { id: "group", name: "Group" },
              { id: "user", name: "Specific User" }
            ]}
            onChangeCustomHandler={key => {
              this.setState({ send_to: key });
            }}
          />
        )}
        {type === 1 &&
          send_to === "user" && (
            <ArrayInput source="user" validate={[required()]}>
              <SimpleFormIterator>
                <ReferenceInput
                  label="Email"
                  source="id"
                  reference="user"
                  validate={[required()]}
                >
                  <AutocompleteInput
                    source="email"
                    optionText={value => `${value.email} ${value.provider || ""}`}
                  />
                </ReferenceInput>
              </SimpleFormIterator>
            </ArrayInput>
          )}
        {type === 1 &&
          send_to === "group" && (
            <ReferenceInput source="group" reference="group">
              <SelectInput optionText="name" />
            </ReferenceInput>
          )}
        {type === 5 && (
          <TextInput source="title" fullWidth validate={[required()]} />
        )}
        {type === 5 && (
          <ArrayInput source="user" validate={[required()]}>
            <SimpleFormIterator>
              <ReferenceInput
                source="id"
                label="Email"
                reference="user"
                validate={[required()]}
              >
                <AutocompleteInput
                  source="email"
                  optionText={value => `${value.email} ${value.provider || ""}`}
                />
              </ReferenceInput>
            </SimpleFormIterator>
          </ArrayInput>
        )}
        {type === 5 && (
          <FileInput
            validate={[required()]}
            source="file"
            accept="application/pdf"
          >
            <FileField target="_blank" source="url" title="File" />
          </FileInput>
        )}
        {/* {
                    (type === 1 && send_to === 'condo') &&
                    <ReferenceInput
                        label="Project name"
                        source="condo"
                        filter={{ _id: project }}
                        validate={[required()]}
                        reference="project">
                        <SelectInput optionText="name" />
                    </ReferenceInput>
                } */}
        {type === 1 && (
          <TextInput source="title" fullWidth validate={[required()]} />
        )}
        {type === 1 && (
          <LongTextInput source="message" validate={[required()]} />
        )}
        {type === 1 && (
          <ImageInput multiple={false} source="image" accept="image/*">
            <ImageField source="url" title="title" />
          </ImageInput>
        )}
        {(type === 3 || type === 4) && (
          <ReferenceInput
            allowEmpty
            filter={{ project }}
            // filterToQuery={searchText => ({ name_contain: searchText })}
            source="room"
            reference="room"
            validate={[required()]}
          >
            <AutocompleteInput optionText="name" />
          </ReferenceInput>
        )}
        {(type === 3 || type === 4) && (
          <SelectInput
            source="bill_month"
            // defaultValue={thisMonth}
            validate={[required()]}
            choices={month}
          />
        )}
        {(type === 3 || type === 4) && (
          <SelectInput
            source="bill_year"
            // defaultValue={thisYear}
            validate={[required()]}
            choices={year()}
          />
        )}
        {(type === 3 || type === 4) && (
          <ImageInput
            multiple={false}
            validate={[required()]}
            source="image"
            accept="image/*"
          >
            <ImageField source="url" title="title" />
          </ImageInput>
        )}
      </SimpleForm>
    );
  }
}

const CustomSelectInput = ({ onChangeCustomHandler, ...rest }) => (
  <SelectInput
    onChange={(event, key, payload) => {
      onChangeCustomHandler(key);
    }}
    {...rest}
  />
);

export default MessageForm;



// WEBPACK FOOTER //
// ./src/components/message/MessageForm.js